import React, { useEffect, useRef } from 'react';
import { Quill } from 'react-quill';
import 'quill/dist/quill.snow.css'; // Import Quill stylesheet

const BasicQuillEditor = ({
  quillEditor,
  setQuillEditor,
  readOnly,
  editorStyle
}) => {
  const Quillref = useRef(null);

  useEffect(() => {
    const modules = {
      toolbar: false
    };

    const editor = new Quill(Quillref.current, {
      theme: 'snow',
      readOnly,
      modules
    });
    setQuillEditor(editor);

    // Apply custom styles if necessary
    Object.assign(Quillref.current.style, {
      width: '100%',
      outline: 'none',
      padding: '10px',
      fontSize: '14px',

      '--bs-border-opacity': '1 !important',
      borderColor:
        'rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important',

      ...editorStyle
    });

    return () => {
      //@ts-ignore
      editor.off('text-change');
    };
  }, [readOnly]);

  return <div ref={Quillref} style={{ ...editorStyle }}></div>;
};

export default BasicQuillEditor;
